import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { CourseModel } from '../course/course.model';
import { ExerciseModel } from '../exercise/exercise.model';
import { ProblemModel } from '../problem/problem.model';


class LessonModel extends BaseModel {

  title: string = undefined as any;
  description: string = undefined as any;
  strategyLessonEnabled: number = undefined as any;
  smartSaversEnabled: number = undefined as any;
  showCorrectEnabled: number = undefined as any;
  showMetricsEnabled: number = undefined as any;
  openAnswerOnComplete: number = undefined as any;

  @JsonProperty({ clazz: CourseModel })
  course: CourseModel = undefined as any;

  @JsonProperty({ clazz: ExerciseModel })
  exercises: ExerciseModel[] = [];
}

class NextLessonModel {

  @JsonProperty({ clazz: LessonModel })
  lesson: LessonModel = undefined as any;
  nextExerciseId: number = undefined as any;
}

class DashboardLessonModel {

  @JsonProperty({ clazz: LessonModel })
  lesson: LessonModel = undefined as any;
  nextExerciseId: number = undefined as any;
}


export { LessonModel, NextLessonModel, DashboardLessonModel };
